// extracted by mini-css-extract-plugin
module.exports = {"list":"ChipSelect_list__5d9Uz","chip":"ChipSelect_chip__3fx8c","disabled":"ChipSelect_disabled__100mq","selected":"ChipSelect_selected__20YyC"};